export default __webpack_public_path__ + "static/media/budget2.409baa1c.png";